import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Markdown from '../../components/Markdown';
import Placeholder from '../../components/Placeholder';

import { Wrapper, Flexbox, TitleSection, Title, Duration, Description, Button } from './TreatmentOverview.style';

const TreatmentOverview = ({ copy, name, duration, description, locale }) => (
  <Wrapper>
    <Flexbox>
      <TitleSection>
        <Title>{name || <Placeholder h="45px" w="60%" />}</Title>
        {(!name || duration) && (
          <Duration>
            {duration ? `${duration} ${copy.minutes || 'Minutes'}` : <Placeholder h="25px" w="20%" />}
          </Duration>
        )}
      </TitleSection>
      {description ? (
        <Markdown src={description} Component={Description} />
      ) : (
        <Description>
          <Placeholder h="135px" w="100%" />
        </Description>
      )}
    </Flexbox>

    <Link to={`/${locale}/salon-locator`} href={`/${locale}/salon-locator`}>
      <Button>{copy.find_a_salon || <Placeholder w="100px" h="20px" />}</Button>
    </Link>
  </Wrapper>
);

TreatmentOverview.defaultProps = {
  copy: {},
  description: undefined,
  duration: undefined,
  name: undefined,
};

TreatmentOverview.propTypes = {
  copy: PropTypes.shape(),
  description: PropTypes.string,
  duration: PropTypes.number,
  locale: PropTypes.string.isRequired,
  name: PropTypes.string,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyTreatmentPage,
  locale: state.locale,
});

export default connect(mapState)(TreatmentOverview);



// WEBPACK FOOTER //
// ./src/pages/TreatmentPage/TreatmentOverview.js